import { PageListCachedDataSource } from './BaseDataSources';
import { IBuyer } from '../Interfaces';

export class BuyerSource extends PageListCachedDataSource<IBuyer> {
  /**
  * @param {boolean} isActive - An optional parameter for filtering active records.
  */
  public constructor(isActive?: boolean) {
    super('/datasource/buyers', { isActive });
  }
}